import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useWindowSize } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowLeft, IconLlmArrowRight } from '@websolutespa/bom-mixer-icons';
import { useRef } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { clamp } from '../../utils.js';
import { Event } from '../Event/event.js';

const EventGroup = props => {
  const {
    item
  } = props;
  useWindowSize();
  const classNames = getClassNames('llm__events');
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperProps = {
    modules: [Navigation],
    spaceBetween: clamp(16, 24),
    slidesPerView: 1.1,
    watchOverflow: true,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    },
    breakpoints: {
      630: {
        slidesPerView: 1.5
      },
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 2.5
      },
      1280: {
        slidesPerView: 3
      }
    }
  };
  return jsx("div", {
    className: classNames,
    children: jsxs(Swiper, Object.assign({}, swiperProps, {
      children: [jsxs("div", {
        className: "llm__events-nav",
        children: [jsx("button", {
          ref: navigationPrevRef,
          children: jsx(IconLlmArrowLeft, {})
        }), jsx("button", {
          ref: navigationNextRef,
          children: jsx(IconLlmArrowRight, {})
        })]
      }), item.items.map((item, i) => jsx(SwiperSlide, {
        className: "llm__events-slide",
        children: jsx(Event, Object.assign({}, props, {
          item: item
        }))
      }, i))]
    }))
  });
};

export { EventGroup };
//# sourceMappingURL=event-group.js.map
